const styles = {
    headline: {
        fontSize: 24,
        paddingTop: 16,
        marginBottom: 12,
        fontWeight: 400,
    },
    slide: {
        padding: 10
    },
    tabHeader:{
        color: '#02aac9',
        backgroundColor :'#fff'
    },
    tabsHeader:{
        marginTop:3,
        backgroundColor: '#fff',
        color: '#02aac9',

    },
    inkBarStyle: {
        background: '#02aac9'
    }
  };

export default styles;


// WEBPACK FOOTER //
// ./src/containers/crashDashboard/styles/CrashDashboardStyles.js